module.exports = "<p>\n  pagos-separados works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/pagos-separados/pagos-separados.component.html
// module id = ../../../../../src/app/pagos-separados/pagos-separados.component.html
// module chunks = 0